function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { routes } from "../../constants";
import { relationshipModel, UserRole } from "../../models";
import { hasClientViewPermission, RelationshipStatus } from "../../models/relationship";
import { formatDateTimeWithLongMonth } from "../../utils";
import { getTimezoneAbbreviation } from "../../utils/date-timezone.utils";
import { COBStep, getCommonReachableSteps } from "./ClientOnboarding.common.utils";

// Re-export common types and enums

export { COBStep, getStepName, PreviewState, termsOfServiceStepIndex } from "./ClientOnboarding.common.utils";
export function getReachableSteps(relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS) {
  return [COBStep.welcome, ...getCommonReachableSteps(relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS), COBStep.allSet];
}
export let Reason = function (Reason) {
  Reason[Reason["PaymentMethod"] = COBStep.paymentMethod] = "PaymentMethod";
  Reason[Reason["ReviewServices"] = COBStep.reviewServices] = "ReviewServices";
  Reason[Reason["SelectAPackage"] = COBStep.selectAPackage] = "SelectAPackage";
  Reason["ApproveTermsOfServices"] = "approveTermsOfServices";
  Reason["ReviewerApprove"] = "reviewerApprove";
  return Reason;
}({});
export const reasonToText = {
  [Reason.PaymentMethod]: 'To approve the agreement, Please add a payment method.',
  [Reason.ReviewServices]: 'To approve the agreement, It is required to select at least one service.',
  [Reason.SelectAPackage]: 'To approve the agreement, Please select a package.',
  [Reason.ReviewerApprove]: 'You can view and interact with the proposal, but not approve it.',
  [Reason.ApproveTermsOfServices]: 'To approve the agreement, Please agree to the Terms of Service.'
};
export const getNextStepButtonText = (step, relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS) => {
  const reachableSteps = getReachableSteps(relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS);
  const currentStepIndex = reachableSteps.indexOf(step);
  if (currentStepIndex === -1) {
    throw new Error('Unreachable step');
  }
  const nextStep = reachableSteps[currentStepIndex + 1];
  if (!nextStep) {
    throw new Error('should have next step');
  }
  if (nextStep === COBStep.selectAPackage) {
    return 'Select a Package';
  }
  if (nextStep === COBStep.paymentMethod) {
    return 'Add payment method';
  }
  switch (step) {
    case COBStep.welcome:
      return relationship.isSample ? 'Review test agreement' : 'Review the agreement';
    default:
      return 'Next';
  }
};
export const getInitialSelectedBundleId = (getFromStorage, relationship, userId) => {
  const fromStorage = getFromStorage('selected_bundle_id');
  if (fromStorage && !relationshipModel.isSignatory(relationship, userId) && !relationshipModel.isReviewer(relationship, userId)) {
    return fromStorage;
  }
  return relationshipModel.selectedBundleId(relationship) || undefined;
};
export const getInitialSelectedOptionalServices = _ref => {
  let {
    setToStorage,
    getFromStorage,
    isPreview,
    relationship,
    selectedBundleID,
    userId
  } = _ref;
  const getInitialSelectedOptionalServices = () => {
    const initialSelectedOptionalServices = relationshipModel.includedByDefaultOptionalServices(relationship, selectedBundleID);
    setToStorage('selected_optional_services', initialSelectedOptionalServices);
    return initialSelectedOptionalServices;
  };
  const fromStorage = getFromStorage('selected_optional_services');
  const fromRelationship = relationshipModel.selectedOptionalServices(relationship);
  const hasSelectedOptionalServices = fromRelationship.length > 0;
  if (isPreview) {
    return getInitialSelectedOptionalServices();
  }
  if (fromStorage && !relationshipModel.isSignatory(relationship, userId) && !relationshipModel.isReviewer(relationship, userId)) {
    return fromStorage;
  }
  if (hasSelectedOptionalServices) {
    setToStorage('selected_optional_services', fromRelationship);
    return fromRelationship;
  }
  return getInitialSelectedOptionalServices();
};
export const getInitialSelectedPaymentMethod = (getFromStorage, relationship, userId) => {
  const selectedPaymentFromStorage = getFromStorage('selected_payment_method');
  if (selectedPaymentFromStorage && !relationshipModel.isSignatory(relationship, userId) && !relationshipModel.isReviewer(relationship, userId)) {
    return selectedPaymentFromStorage;
  } else {
    return {
      fundingSourceId: relationshipModel.selectedFundingSourceId(relationship) || undefined
    };
  }
};
export function isApproveProposalDisabled(disabledReason, isPreview, relationship, userId, role, MULTIPLE_LEGAL_TERMS_DOCUMENTS) {
  if (MULTIPLE_LEGAL_TERMS_DOCUMENTS) {
    if (disabledReason) {
      return true;
    }
    return relationship.isSample || isPreview ? isPreview : !getIsAllowedToSIgn({
      relationship,
      userId,
      role
    });
  }
  const isAllowedToSign = getIsAllowedToSIgn({
    relationship,
    userId,
    role
  });
  const disabled = relationship.isSample || isPreview ? isPreview : !isAllowedToSign;
  if (!disabled && relationshipModel.isSignatory(relationship, userId)) {
    return false;
  }
  return disabled || !!disabledReason;
}
export const getPrimaryRelationshipApprovedNavigateUrl = _ref2 => {
  let {
    relationshipId,
    hasEnteredWizard
  } = _ref2;
  return hasEnteredWizard ? routes.allSet(relationshipId) : routes.agreement(relationshipId);
};
export const getSignatoryRelationshipApprovedNavigateUrl = _ref3 => {
  let {
    hasEnteredWizard,
    role,
    relationshipId
  } = _ref3;
  if (hasEnteredWizard) {
    return routes.allSignaturesAcquired;
  }
  if (!hasClientViewPermission(role)) {
    return routes.noPermissionsRelationshipAlreadyApproved;
  } else {
    return routes.agreement(relationshipId);
  }
};
const getUrl = _ref4 => {
  let {
    relationshipStatus,
    hasStartedWithPendingStatus,
    isPrimary,
    relationshipId,
    role,
    vendorName,
    isVendor
  } = _ref4;
  switch (relationshipStatus) {
    case RelationshipStatus.Approved:
      return {
        url: isPrimary ? getPrimaryRelationshipApprovedNavigateUrl({
          relationshipId,
          hasEnteredWizard: hasStartedWithPendingStatus
        }) : getSignatoryRelationshipApprovedNavigateUrl({
          relationshipId,
          role,
          hasEnteredWizard: hasStartedWithPendingStatus
        })
      };
    case RelationshipStatus.Terminated:
      if (hasClientViewPermission(role)) {
        return {
          url: routes.agreement(relationshipId)
        };
      }
      return null;
    case RelationshipStatus.Canceled:
      return {
        url: routes.canceledProposalPage
      };
    case RelationshipStatus.Pending:
      return null;
    case RelationshipStatus.Expired:
      {
        if (isVendor) return null;
        const state = {
          vendorName
        };
        return {
          url: routes.expiredProposalPage,
          state
        };
      }
  }
};
export function clientOnboardingNavigateStateReducer(state, action) {
  const newState = _objectSpread({}, state);
  switch (action.type) {
    case 'RelationshipStatusChanged':
      newState.relationshipStatus = action.status;
      break;
    default:
      return state;
  }
  const value = getUrl({
    relationshipStatus: newState.relationshipStatus,
    hasStartedWithPendingStatus: newState.hasStartedWithPendingStatus,
    isPrimary: newState.isPrimary,
    relationshipId: newState.relationshipId,
    role: newState.role,
    vendorName: newState.vendorName,
    isVendor: newState.isVendor
  });
  newState.urlToNavigate = (value === null || value === void 0 ? void 0 : value.url) || null;
  newState.state = value === null || value === void 0 ? void 0 : value.state;
  return newState;
}
export function isAllowedToGoBack(url) {
  return url === routes.canceledProposalPage;
}
export function getIsAllowedToSIgn(_ref5) {
  let {
    relationship,
    userId,
    role
  } = _ref5;
  if (relationshipModel.hasSignatories(relationship)) {
    return relationshipModel.isSignatory(relationship, userId) || relationshipModel.isBuyer(relationship, userId);
  } else {
    return relationshipModel.isBuyer(relationship, userId) || role === UserRole.Owner;
  }
}
export function getExpirationDateMessage(expirationDate) {
  if (!expirationDate) return null;

  //im adding +1 to the day because the offer expired at the END of the chosen expiration date
  //if i won't add +1, resetting the time to midnight will be the biginning of this day
  const utcMidnight = new Date(Date.UTC(expirationDate.year, expirationDate.month - 1, expirationDate.day + 1, 0, 0, 0, 0));
  const timezoneAbbreviation = getTimezoneAbbreviation(utcMidnight);
  return "Discounted rates apply if this proposal is approved by ".concat(formatDateTimeWithLongMonth(utcMidnight), " (").concat(timezoneAbbreviation || 'your timezone', ").");
}